<template>
  <img
    v-if="avatarUrl"
    class="user-image"
    :src="avatarUrl"
    :style="{
      width: `${size}px`,
      height: `${size}px`,
    }"
    :alt="user"
  >
  <div
    v-else
    class="user-image"
    :style="{
      width: `${size}px`,
      height: `${size}px`,
      fontSize: `${size}px;`,
    }"
  >
    {{ initial }}
  </div>
</template>

<script>
export default {
  props: {
    userId: {
      type: Number,
      required: true,
    },
    size: {
      type: Number,
      required: false,
      default: 36,
    },
  },
  data() {
    return {
      avatarUrl: '',
      initial: '',
    };
  },
  async mounted() {
    // TODO: this is not efficient to do for every image
    const response = await this.api({ url: `users/${this.userId}/` });

    if (response.ok && response.body.avatar) {
      this.avatarUrl = `https://storage.googleapis.com/vw-gungroup/${response.body.avatar}`;
    } else if (response.body.first_name) {
      // eslint-disable-next-line prefer-destructuring
      this.initial = response.body.first_name[0];
    } else {
      this.initial = '?';
    }
  },
};
</script>

<style lang="scss" scoped>
  img,
  div {
    border-radius: 0.25rem;
    vertical-align: middle;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
  }

  div {
    background-color: #fff;
    color: #333;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }

  .material-design-icon > .material-design-icon__svg {
    position: static;
    color: var(--gray-darker);
  }
</style>
